import { render, staticRenderFns } from "./VideoGalleryPlayer.vue?vue&type=template&id=308c9624&scoped=true&"
import script from "./VideoGalleryPlayer.vue?vue&type=script&lang=js&"
export * from "./VideoGalleryPlayer.vue?vue&type=script&lang=js&"
import style0 from "./VideoGalleryPlayer.vue?vue&type=style&index=0&id=308c9624&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../voicecasting.sk/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "308c9624",
  null
  
)

export default component.exports